import { gsap, ScrollTrigger } from 'gsap/all';
import SplitText from "../__vendor/SplitText.min.js";

gsap.registerPlugin(ScrollTrigger);

const aboutInfoSection = () => {
        const text = new SplitText('.about-us-section h2', { type: "chars" });

        const textLines = new SplitText('.about-us p', { type: "lines" });

        gsap.set(text.chars, {
            opacity: 0,
            y: 30
        });

        gsap.set(textLines.lines, {
            opacity: 0,
            y: 15
        });

        const aboutInfoTl = gsap.timeline({
            paused: true
        });

        aboutInfoTl.to(text.chars, {
            y: 0,
            opacity: 1,
            stagger: 0.06
        }, 0.15).to(textLines.lines, {
            y: 0,
            opacity: 1,
            stagger: 0.1
        }, 0.75)

        ScrollTrigger.create({
            scroller:'[data-scroll-container]',
            trigger: '.about-us-section',
            start: 'top center',
            end: 'bottom center',
            animation: aboutInfoTl,
            toggleActions: 'play none none none',
        });
};

export default aboutInfoSection;